import ComposePopoutData from '../store/schema/ComposePopoutData';
import { ComposeViewState } from 'owa-mail-compose-store';
import { AttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import mailTipsCacheStore from 'owa-mail-tips/lib/store/store';
import clpStore from 'owa-mail-clp/lib/store/store';

export default function prepareComposeViewStateForPopout(
    viewState: ComposeViewState,
    sendOnPopout?: boolean
): ComposePopoutData {
    const attachments: AttachmentModel[] = [];

    // Store Attachment information in Local Storage
    if (viewState.attachmentWell) {
        viewState.attachmentWell.docViewAttachments.forEach(element => {
            attachments.push(getAttachment(element.attachmentId));
        });
        viewState.attachmentWell.imageViewAttachments.forEach(element => {
            attachments.push(getAttachment(element.attachmentId));
        });
        viewState.attachmentWell.inlineAttachments.forEach(element => {
            attachments.push(getAttachment(element.attachmentId));
        });
    }

    const mailtips = mailTipsCacheStore.mailTips
        ? mailTipsCacheStore.mailTips.returnAllMailTipsCacheEntries()
        : null;

    return {
        composeViewState: viewState,
        attachments,
        mailtips,
        clpStore,
        sendMessageOnPoput: sendOnPopout,
    };
}
